import React from 'react';
import { motion } from 'framer-motion';
import { Sun, ClipboardList, Printer, Calendar, Users, Brain, Check } from 'lucide-react';
export function WhatIncludedSection() {
  const features = [{
    icon: <Sun className="w-6 h-6 text-amber-500" data-id="element-228" />,
    title: 'Las 3 rutinas esenciales',
    desc: 'Mañana, tarde y noche. Diseñadas para que no dependan de tu ánimo del día.'
  }, {
    icon: <ClipboardList className="w-6 h-6 text-blue-500" data-id="element-229" />,
    title: 'El tablero «Primero–Después»',
    desc: 'La herramienta más simple para transiciones sin drama.'
  }, {
    icon: <Printer className="w-6 h-6 text-emerald-500" data-id="element-230" />,
    title: 'Plantillas imprimibles listas',
    desc: 'Nada de diseñar desde cero. Imprimes, pegas, aplicas.'
  }, {
    icon: <Calendar className="w-6 h-6 text-purple-500" data-id="element-231" />,
    title: 'Plan de 14 días',
    desc: 'Paso a paso para que no abandones por confusión.'
  }, {
    icon: <Users className="w-6 h-6 text-rose-500" data-id="element-232" />,
    title: 'Casos reales',
    desc: 'Cómo se aplica en familias normales, con caos real.'
  }, {
    icon: <Brain className="w-6 h-6 text-indigo-500" data-id="element-233" />,
    title: 'Estrategias de neurodesarrollo',
    desc: 'Traducidas a lenguaje humano, sin tecnicismos.'
  }];
  return <section className="py-20 bg-amber-50" data-id="element-234">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-235">
        <div className="text-center mb-16" data-id="element-236">
          <h2 className="text-3xl md:text-4xl font-extrabold text-stone-900 mb-4" data-id="element-237">
            ¿Qué incluye exactamente?
          </h2>
          <p className="text-lg text-stone-600" data-id="element-238">
            Todo lo que necesitas para empezar hoy mismo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-239">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 relative group" data-id="element-240">
              <div className="absolute top-4 right-4 bg-emerald-100 text-emerald-600 p-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-241">
                <Check className="w-4 h-4" data-id="element-242" />
              </div>
              <div className="w-12 h-12 bg-stone-50 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-243">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-244">
                {feature.title}
              </h3>
              <p className="text-stone-600 leading-relaxed" data-id="element-245">{feature.desc}</p>
            </motion.div>)}
        </div>

        <div className="flex justify-center" data-id="element-246">
          <div className="inline-flex items-center gap-2 bg-emerald-100 text-emerald-800 px-6 py-3 rounded-full font-bold text-lg shadow-sm" data-id="element-247">
            <Printer className="w-5 h-5" data-id="element-248" />
            +25 Plantillas Imprimibles incluidas
          </div>
        </div>
      </div>
    </section>;
}